// In-memory vessel session store.
// Intentionally NOT persisted to localStorage — cleared on page refresh.
// This is by design for shared vessel devices.

export interface VesselSession {
  token: string;
  id: string;
  name: string;
  imo_number: string | null;
}

let session: VesselSession | null = null;

export function setVesselSession(s: VesselSession): void {
  session = s;
}

export function getVesselSession(): VesselSession | null {
  return session;
}

export function clearVesselSession(): void {
  session = null;
}

export function isVesselAuthenticated(): boolean {
  return session !== null;
}
